/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { daysFromNow, parseDateTime } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';

import { buildUpgradeUrl } from './utils';
import type { Result } from '../useAlertBanner/alertBannerNotificationsQuery';

import { BannerProps } from './types';

import { useUniversalNavContext } from '../../../../universal-nav/hooks';

export const shouldRender = (data: Result['data']) => {
  const { isCompanyAccount, companiesTrialEndDate } = data.currentAccount;

  if (!companiesTrialEndDate || isCompanyAccount) return false;

  const companiesTrialHasEnded =
    parseDateTime(companiesTrialEndDate) < new Date();
  return companiesTrialHasEnded && daysFromNow(companiesTrialEndDate) <= 7;
};

export const Component = function CompaniesTrialEnded(props: BannerProps) {
  const { getFullyQualifiedURL } = useUniversalNavContext();

  const { data } = props;
  const { currentAccount } = data;
  const upgradeUrl = buildUpgradeUrl({
    currentPlanName: currentAccount.plan.name,
    upgradePlanName: data.nextCompanyPlan?.name,
    interval: currentAccount.plan.interval,
  });

  const onUpgrade = () => {
    props.trackEvent('company-trial-ended-upgrade-clicked', {
      profileId: data.currentUser.id,
    });
  };

  const onContactSupport = () => {
    props.trackEvent('company-trial-ended-support-extend-trial-clicked', {
      profileId: data.currentUser.id,
    });
  };

  return (
    <Alert
      layout={props.layout}
      title="Your Company trial has ended"
      type="info"
    >
      <Link href={getFullyQualifiedURL(upgradeUrl)} onClick={onUpgrade}>
        Upgrade
      </Link>{' '}
      to keep using our advanced administrative and security controls. Still
      have questions?{' '}
      <Link
        href={getFullyQualifiedURL('/app/get-help')}
        onClick={onContactSupport}
      >
        Contact us
      </Link>{' '}
    </Alert>
  );
};
